import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";

import { BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';

function Header() {
	useEffect(() => {
		const links = document.querySelectorAll('a[href^="#"]');

		const handleSmoothScroll = (e) => {
			e.preventDefault();
			const targetId = e.currentTarget.getAttribute("href");
			const targetElement = document.querySelector(targetId);

			if (targetElement) {
				window.scrollTo({
					top: targetElement.offsetTop - 70, // adjust offset for fixed header
					behavior: "smooth",
				});
			}
		};

		links.forEach((link) => link.addEventListener("click", handleSmoothScroll));

		// cleanup
		return () =>
			links.forEach((link) =>
				link.removeEventListener("click", handleSmoothScroll)
			);
	}, []);

    return (
         <>
		<style>
		{
			`
				header a{
					color:#D21677 !important;
				}
				.btn-pink{
					background:#D21677 !important;
					color:#ffff !important;
				}
				.bg-pink{
					background:#D21677 !important;
					color:#ffff !important;
				}
				.text-pink{
					color:#D21677 !important;
				}

				@media (max-width: 991px) {
					#header .header-nav-main.header-nav-main-mobile-dark:before {
						background-color: #dedede;
					}
				}
				@media (max-width: 991px) {
					#header .header-nav-main.header-nav-main-mobile-dark nav > ul > li > a {
						color: #D21677 !important;
					}
				}
				@media (max-width: 991px) {
					#header .header-nav-main.header-nav-main-mobile-dark nav > ul li {
						border-bottom: 1px solid #D21677;
					}
				}
				@media (max-width: 991px) {
					#header .header-nav-main.header-nav-main-mobile-dark nav > ul > li > a.active {
						background: #D21677 !important;
						color: #fff !important;
					}
				}
					.navbar .nav-link li {
					text-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
					}

					.navbar .nav-link.active {
					text-shadow: 0 2px 6px rgba(0, 0, 0, 0.6);
					}
			`
		}
		</style>
        <div>
            <header id="header" className="header-transparent header-effect-shrink" data-plugin-options="{'stickyEnabled': true, 'stickyEffect': 'shrink', 'stickyEnableOnBoxed': true, 'stickyEnableOnMobile': false, 'stickyChangeLogo': true, 'stickyStartAt': 30, 'stickyHeaderContainerHeight': 70}">
					<div className="border-top-0 box-shadow-none" style={{ backgroundColor: '#ffffff', color: '#000000' }}>
					<div className="header-container container">
						<div className="header-row">
							<div className="header-column">
								<div className="header-row">
									<div className="header-logo">
										<NavLink to="/home">
												<img alt="Radius Exhibition Fixtures" src="/assets/img/logos/Logo-300x43.png" style={{ width: '300px' }}/>
										</NavLink>
									</div>
								</div>
							</div>
							<div className="header-column justify-content-end">
								<div className="header-row">
										<div className="header-nav header-nav-links header-nav-dropdowns-dark header-nav-light-text order-2 order-lg-1">
											<div className="header-nav-main header-nav-main-font-lg header-nav-main-font-lg-upper-2 header-nav-main-mobile-dark header-nav-main-square header-nav-main-dropdown-no-borders header-nav-main-effect-2 header-nav-main-sub-effect-1">
											<nav className="collapse">
												<ul className="nav nav-pills" id="mainNav">
													<li>
														<NavLink to="/home" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>Home</NavLink>
													</li>
													<li>
														<NavLink to="/about" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>About</NavLink>
													</li>
													<li>
														<NavLink to="/services" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>Services</NavLink>
													</li>
													<li>
														<NavLink to="/projects" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>Projects</NavLink>
													</li>
													<li>
														<NavLink to="/careers" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>Careers</NavLink>
													</li>
													<li>
														<NavLink to="/contact" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>Contact</NavLink>
													</li>
													
												</ul>
											</nav>
										</div>
										<button className="btn header-btn-collapse-nav" data-bs-toggle="collapse" data-bs-target=".header-nav-main nav" style={{ height: '50px', width: '50px', background: 'none', color: '#D21677' }}>
											<i className="fas fa-bars" style={{ fontSize: '25px', fontWeight: '900', textShadow: '0.5px 2px 3px currentColor' }}></i>
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</header>
        </div>
        </>
    );
}

export default Header;
